export default function TestimonialsSection() {
  const testimonials = [
    {
      quote:
        "1440 has been great for me inside of work and out. During the day, it helps me be productive and start the morning with clarity and drive. Outside of work, it's helped me accomplish my goals fitness and my hobbies. I've had a couple friends join so far too and we're taking on group challenges every month.",
      name: "David Brown",
      title: "Consultant",
    },
    {
      quote:
        "I integrated my Garmin and did marathon planning and have check-ins which has been great. Then the other day I missed a long run, and it actually called me and asked if it was intentional. It now sends me these morning voicemails with positive affirmations before my long runs and I've kept up the training since",
      name: "Noah Lloyd",
      title: "Student",
    },
    {
      quote:
        "I have this late night habit where I keep unconsciously falling back into scrolling on my phone whenever my mind gets tired or bored after work or dinner. Lately, instead of wasting another couple of hours, I've just been checking in with 1440 to talk through my thoughts, and why and how my habit persists. Result is that I haven't doomscrolled in the last 3 months - couldn't be happier.",
      name: "Mike Hansen",
      title: "Software Engineer",
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-secondary/50 border-y-2 border-border">
      <div className="container mx-auto px-4 md:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center space-y-12 mb-20">
            <div className="space-y-6">
              <span className="text-primary text-sm font-bold tracking-wider uppercase">
                PROVEN RESULTS
              </span>
              <h2 className="text-3xl md:text-5xl xl:text-6xl font-bold md:font-extrabold leading-[0.9] tracking-tighter text-foreground max-w-4xl mx-auto">
                Real people. <span className="text-primary">Real change.</span>
              </h2>
            </div>
            <div className="w-24 h-1 bg-primary mx-auto"></div>
          </div>

          {/* Testimonials grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-card border-2 border-border p-8 hover:border-primary hover:shadow-brutal hover:translate-x-1 hover:translate-y-1 transition-spring group"
              >
                <div className="space-y-8">
                  {/* Quote */}
                  <blockquote className="text-lg font-medium text-foreground leading-relaxed">
                    "{testimonial.quote}"
                  </blockquote>

                  {/* Attribution */}
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 border-2 border-primary bg-background flex items-center justify-center group-hover:bg-primary transition-colors">
                      <span className="text-lg font-black text-primary group-hover:!text-black">
                        {testimonial.name.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <p className="font-bold text-foreground mb-0">
                        {testimonial.name}
                      </p>
                      <p className="text-sm text-muted-foreground">
                        {testimonial.title}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
